<template>
  <div>
    <transactions
      :transaction-class="transactionClass"
      verbose-name="Facture"
      verbose-name-plural="Factures"
      ressource="invoices"
      :additional-params="{ expense: $route.params.expense }"
      :colors="colors"
    ></transactions>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import Transactions from '@/router/view/commercial/components/transactions'

const { Invoice } = Hk.Crm
export default {
  name: 'invoices',

  components: {
    Transactions,
  },

  data() {
    return {
      transactionClass: null,
      colors: {
        pro_format: 'warning',
        accepted: 'success',
        canceled: 'danger',
      },
    }
  },

  mounted() {
    this.transactionClass = Invoice
  },
}
</script>

<style></style>
